/* eslint-disable */
class ItemListBase {
  constructor(scene) {
    this.name;
    this.scene = scene;
    this.meshList = [];
    this.root;
  }

  //create root mesh
  createRoot() {
    this.root = BABYLON.MeshBuilder.CreateGround(
      this.name + "_root",
      { width: 0.01, height: 0.01 },
      this.scene
    );

    this.root.visibility = 0;
  }

  //create models
  create(acc, data, position, size, boundary) {}

  //create material
  createMaterial(id, color, metallic, roughness) {
    let material = new BABYLON.PBRMetallicRoughnessMaterial(id, this.scene);

    if (color) material.baseColor = color;
    if (metallic) material.metallic = metallic;
    if (roughness) material.roughness = roughness;

    return material;
  }

  finalize() {
    this.meshList.forEach(item => {
      item.finalize();
    });

    this.meshList = [];
  }

  getRoot() {
    return this.root;
  }
}

export default ItemListBase;
